export enum IllustrationCountCategory {
    OneToFive = 1,
    SixToTen = 2,
    ElevenToFifty = 3,
    FiftyOneToOneHundred = 4,
    HundredOneAndMore = 5
}